<script setup lang="ts">
  import {
    Empty,
    EmptyContent,
    EmptyDescription,
    EmptyHeader,
    EmptyMedia,
    EmptyTitle
  } from '@gat-ship/vue-components'
  import { IconFilter, IconSearch } from '@gat-ship/icons'

  /**
   * The empty state for a list step: "no matches" once a search has run, or a
   * prompt before the user types (search-first steps). The default slot fills
   * the action area below — used by the vessel step for its "to be named"
   * button.
   */
  defineProps<{
    /** Server-search steps before the first keystroke: show the prompt. */
    awaitingFirstSearch?: boolean
    /** Title shown when the list is empty. */
    title?: string
    /** Prompt shown while awaiting the first search. */
    prompt?: string
    /** Text shown when the list is empty. */
    emptyText?: string
    /** Whether the list is a filter list. */
    isFilter?: boolean
  }>()
</script>

<template>
  <Empty>
    <EmptyHeader>
      <EmptyMedia variant="icon">
        <component :is="isFilter ? IconFilter : IconSearch" />
      </EmptyMedia>
      <EmptyTitle v-if="!awaitingFirstSearch">{{
        title ?? 'No matches'
      }}</EmptyTitle>
      <EmptyDescription>
        {{
          awaitingFirstSearch
            ? (prompt ?? 'Start typing to search…')
            : (emptyText ?? 'Try a different name or code.')
        }}
      </EmptyDescription>
    </EmptyHeader>
    <EmptyContent v-if="$slots.default">
      <slot />
    </EmptyContent>
  </Empty>
</template>
